/**
 * History teaser - Figma `6377:87736`.
 *
 * Two panels side by side: a grey card with the eyebrow, heading, body and a call to
 * action, and a blue panel carrying a single year at display size with a caption under
 * it.
 *
 * **The section gained `yearCaption`** - the line under the year had nowhere to live;
 * `body` is the paragraph in the grey card.
 *
 * The year is decorative typography, so it is a `<p>` rather than a heading: putting
 * "1994" in the document outline as a heading would be noise for anyone navigating by
 * headings.
 */
import { CtaLink, Eyebrow, SectionShell } from '../primitives';
import type { HistoryTeaserSection } from '../../types/sections';

export default function HistoryTeaser({ data }: { data: HistoryTeaserSection }) {
  return (
    <SectionShell settings={data.settings} name="history-teaser">
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="flex flex-col justify-between gap-8 rounded-l bg-surface-muted p-8">
          <div className="flex flex-col gap-6">
            {data.eyebrow ? <Eyebrow value={data.eyebrow} /> : null}
            <h2 className="text-h4 text-ink">{data.heading}</h2>
            {data.body ? <p className="whitespace-pre-line text-body-sm text-ink-muted">{data.body}</p> : null}
          </div>
          {data.cta ? <CtaLink value={data.cta} /> : null}
        </div>

        <div className="flex min-h-[280px] flex-col items-center justify-center gap-4 rounded-l bg-brand-500 p-8 text-white">
          {data.year ? <p className="text-display leading-none">{data.year}</p> : null}
          {data.yearCaption ? (
            <p className="max-w-sm text-center text-body-sm text-white/80">{data.yearCaption}</p>
          ) : null}
        </div>
      </div>
    </SectionShell>
  );
}
